<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="title">
          <el-input
            v-model="listQuery.title"
            placeholder="请输入表名"
            style="width: 300px;"
            clearable
            @change="SearchData"
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button
          class="action-item"
          type="primary"
          @click="LoadDataTable"
        >装载数据表</el-button>
        <!--        <el-button class="action-item" type="primary" @click="Export">测试导出</el-button>-->
        <el-button class="action-item" @click="BatchDelete">删除</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />
      <el-table-column
        align="center"
        prop="table_name"
        label="表名"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="table_comment"
        label="描述"
      ></el-table-column>
      <el-table-column align="center" prop="type" label="生成类型">
        <template slot-scope="{ row }">
          <!--          single 单表CRUD，tree 树表CRUD，parent_sub父子表CRUD-->
          <el-tag v-if="row.type == 'single'" type="success">单表CRUD</el-tag>
          <el-tag v-if="row.type == 'tree'" type="success">树表CRUD</el-tag>
          <el-tag
            v-if="row.type == 'parent_sub'"
            type="success"
          >父子表CRUD</el-tag>
          <el-tag v-if="row.type == 1" type="success">单表CRUD</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="添加时间"
        sortable
      ></el-table-column>
      <el-table-column
        align="center"
        prop=""
        label="操作"
        width="250"
        class-name="action"
      >
        <template slot-scope="scopes">
          <el-button
            type="primary"
            size="mini"
            @click="preview(scopes.row)"
          >预览</el-button>
          <!--          <el-button type="text" plain size="mini" @click="HandleUpdate(scopes.row)">同步</el-button>-->
          <el-button
            type="warning"
            size="mini"
            @click="HandleUpdate(scopes.row)"
          >编辑</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="generate(scopes.row)"
          >生成代码</el-button>
          <!--          <el-button type="text" plain size="mini" @click="RowDelete(scopes.row)">删除</el-button>-->
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />

    <!--装载数据表-->
    <el-dialog :title="'装载数据表'" :visible.sync="dialogDataVisible">
      <el-form :inline="true">
        <el-form-item label="数据表名称">
          <el-input
            v-model="DataListQuery.title"
            placeholder="请输入数据表名称"
            clearable
            @change="SearchBaseData"
            @keyup.enter.native="SearchBaseData"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="SearchBaseData">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表 -->
      <el-table v-loading="loading" :data="DataBaselist">
        <el-table-column
          align="center"
          prop="Name"
          label="表名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Comment"
          label="表描述"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scopes">
            <el-button
              size="mini"
              type="primary"
              @click="selectData(scopes.row)"
            >点击选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="DataBasetotal > 0"
        :total="DataBasetotal"
        :page.sync="DataListQuery.page"
        :limit.sync="DataListQuery.limit"
        @pagination="DataBaseList"
      />
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogFormVisible"
      :fullscreen="true"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="80px"
        style="width: 100%"
      >
        <el-tabs type="border-card">
          <el-tab-pane label="配置信息">
            <el-divider content-position="left">基础信息</el-divider>
            <el-form-item label="表名称" prop="table_name">
              <el-input v-model="subData.table_name" disabled />
            </el-form-item>
            <el-form-item label="表描述" prop="table_comment">
              <el-input v-model="subData.table_comment" disabled />
            </el-form-item>
            <el-divider content-position="left">生成信息</el-divider>
            <!--          <el-form-item label="所属模块" prop="module_name">-->
            <!--            <el-input v-model="temp.module_name"/>-->
            <!--          </el-form-item>-->

            <el-form-item label="菜单名称" prop="menu_name">
              <el-input v-model="subData.menu_name" />
              <p>显示在左侧菜单上的名称、以及以及代码中的业务名称</p>
            </el-form-item>

            <el-form-item label="生成方式" prop="generate_type">
              <el-radio-group v-model="subData.generate_type">
                <el-radio-button :label="1">压缩包下载</el-radio-button>
                <el-radio-button :label="2">生成到模块</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="生成类型" prop="type">
              <el-radio-group v-model="subData.type">
                <el-radio-button label="single">单表CRUD</el-radio-button>
                <el-radio-button label="tree">树表CRUD</el-radio-button>
                <el-radio-button label="parent_sub">父子表CRUD</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="模块名称" prop="package_name">
              <el-input v-model="subData.package_name" />
              <p>
                如：generate,将会生成namespace app\admin\controller\generate;
              </p>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="字段配置">
            <el-table :data="subData.columns" border style="width: 100%">
              <el-table-column
                prop="column_name"
                label="字段名称"
              ></el-table-column>
              <el-table-column prop="column_comment" label="字段描述">
                <template slot-scope="{ row }">
                  <el-input v-model="row.column_comment" />
                </template>
              </el-table-column>
              <el-table-column
                prop="column_type"
                label="物理类型"
              ></el-table-column>
              <el-table-column prop="is_list" label="列表显示">
                <template slot-scope="{ row }">
                  <el-checkbox
                    v-model="row.is_list"
                    :true-label="2"
                    :false-label="1"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="is_insert" label="插入显示">
                <template slot-scope="{ row }">
                  <el-checkbox
                    v-model="row.is_insert"
                    :true-label="2"
                    :false-label="1"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="is_query" label="查询条件">
                <template slot-scope="{ row }">
                  <el-checkbox
                    v-model="row.is_query"
                    :true-label="2"
                    :false-label="1"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="is_sort" label="排序字段">
                <template slot-scope="{ row }">
                  <el-checkbox
                    v-model="row.is_sort"
                    :true-label="2"
                    :false-label="1"
                  />
                </template>
              </el-table-column>

              <el-table-column prop="view_type" label="页面控件">
                <template slot-scope="{ row }">
                  <el-select v-model="row.view_type" placeholder="请选择">
                    <el-option
                      v-for="item in viewComponent"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="参数设置" align="center" width="80px">
                <template slot-scope="{ row }">
                  <el-button
                    v-if="!notNeedSettingComponents.includes(row.view_type)"
                    type="text"
                    size="mini"
                    round
                    @click="viewComponentSetting(row)"
                  >设置</el-button>
                </template>
              </el-table-column>

              <el-table-column label="数据字典" align="center">
                <template slot-scope="{ row }">
                  <!--                  :disabled="! ['select', 'radio', 'checkbox', 'transfer'].includes(record.view_type)"-->
                  <el-select
                    v-model="row.dict_type"
                    placeholder="请选择数据字典"
                    :disabled="
                      !['select', 'radio', 'checkbox', 'transfer'].includes(
                        row.view_type
                      )
                    "
                  >
                    <el-option
                      v-for="item in dict_type"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="query_type" label="查询方式">
                <template slot-scope="{ row }">
                  <el-select v-model="row.query_type" placeholder="请选择">
                    <el-option
                      v-for="item in queryTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="菜单配置">
            <el-checkbox-group v-model="subData.generate_menus">
              <el-checkbox
                v-for="item in menuList"
                :key="item.value"
                :label="item.value"
                style="display: block;margin-bottom: 20px"
              >
                {{ item.name }} - {{ item.comment }}
              </el-checkbox>
            </el-checkbox-group>
          </el-tab-pane>
          <el-tab-pane label="关联配置">
            <el-button
              type="primary"
              plain
              @click="addComposition"
            >新增关联</el-button>
            <div
              v-for="(item, index) in subData.options.relations"
              :key="index"
            >
              <el-divider
                content-position="left"
              >定义新关联
                <el-button
                  size="mini"
                  icon="el-icon-delete"
                  type="text"
                  style="margin-left: 20px"
                  @click="deleteComposition(index)"
                >删除定义
                </el-button>
              </el-divider>

              <el-row :gutter="20">
                <el-col :span="9">
                  <el-form-item label="关联模型" prop="model">
                    <el-input v-model="item.model" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="关联名称" prop="name">
                    <el-input v-model="item.name" />
                    <p>设置关联名称，且是代码中调用的名称</p>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="9">
                  <el-form-item label="关联键" prop="localKey">
                    <el-select v-model="item.localKey" placeholder="请选择">
                      <el-option
                        v-for="it in subData.columns"
                        :key="it.column_name"
                        :label="it.column_name + '-' + it.column_comment"
                        :value="it.column_name"
                      ></el-option>
                    </el-select>
                    <p>关联键，是指本表的外键</p>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="外键" prop="foreignKey">
                    <el-input v-model="item.foreignKey" />
                    <p>关联表外键或中间表的外键</p>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="9">
                  <el-form-item label="关联类型" prop="type">
                    <el-select v-model="item.type" placeholder="请选择">
                      <el-option
                        v-for="it in realtionsType"
                        :key="it.value"
                        :label="it.label"
                        :value="it.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11"> </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmUpdateData">保存</el-button>
      </div>
    </el-dialog>

    <!--预览-->
    <el-dialog title="预览" :visible.sync="dialogPreviewVisible" width="80%">
      <el-tabs>
        <el-tab-pane
          v-for="item in PreviewData"
          :key="item.name"
          :label="item.tab_name"
        >
          <!--          {{ item.code }}-->
          <CodeEdit v-model="item.code" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!--    页面控件-->

    <el-dialog
      title="页面控件参数设置"
      :visible.sync="viewComponentVisible"
      width="50%"
    >
      <el-form
        ref="viewColumnForm"
        :model="viewColumnForm"
        label-position="left"
        label-width="80px"
        style="width: 100%"
      >
        <!--        多选\复选\单选-->
        <div
          v-if="
            ['select', 'checkbox', 'radio', 'transfer'].includes(
              viewColumnRow.view_type
            )
          "
        >
          <el-form-item
            v-if="viewColumnRow.view_type == 'select'"
            label="是否多选"
          >
            <el-radio
              v-model="viewColumnForm.multiple"
              :label="true"
            >是</el-radio>
            <el-radio
              v-model="viewColumnForm.multiple"
              :label="false"
            >否</el-radio>
          </el-form-item>
          <el-button type="primary" plain @click="add">新增数据</el-button>
          <div v-for="(item, index) in viewColumnForm.collection" :key="index">
            <el-divider
              content-position="left"
            >新增数据
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="text"
                style="margin-left: 20px"
                @click="del(index)"
              >删除</el-button>
            </el-divider>
            <el-row :gutter="20">
              <el-col :span="9">
                <el-form-item label="名称">
                  <el-input v-model="item.label" />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="值">
                  <el-input v-model="item.value" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!--        数字\滑块-->
        <div
          v-if="
            viewColumnRow.view_type == 'inputNumber' ||
              viewColumnRow.view_type == 'slider'
          "
        >
          <el-form-item label="最小值">
            <el-input-number
              v-model="viewColumnForm.min"
              :min="1"
              :precision="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="最大值">
            <el-input-number
              v-model="viewColumnForm.max"
              :min="1"
              :precision="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="步长">
            <el-input-number
              v-model="viewColumnForm.step"
              :min="0"
              :precision="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-if="viewColumnRow.view_type != 'slider'" label="精度">
            <el-input-number
              v-model="viewColumnForm.precision"
              :min="0"
              :max="4"
              :precision="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            v-if="viewColumnRow.view_type != 'inputNumber'"
            label="刻度线"
          >
            <el-radio
              v-model="viewColumnForm.showTicks"
              :label="true"
            >显示</el-radio>
            <el-radio
              v-model="viewColumnForm.showTicks"
              :label="false"
            >不显示</el-radio>
          </el-form-item>
        </div>
        <!--        开关-->
        <div v-if="viewColumnRow.view_type == 'switch'">
          <el-form-item label="选中时的值" label-width="110px">
            <el-input v-model="viewColumnForm.checkedValue" />
          </el-form-item>
          <el-form-item label="未选中时的值" label-width="110px">
            <el-input v-model="viewColumnForm.uncheckedValue" />
          </el-form-item>
        </div>
        <!-- 日期、时间选择器 -->
        <div v-if="['time', 'date'].includes(viewColumnRow.view_type)">
          <el-form-item
            v-if="viewColumnRow.view_type == 'date'"
            label="选择器类型"
            label-width="110px"
          >
            <el-select v-model="viewColumnForm.mode" placeholder="请选择">
              <el-option label="年选择器" value="year"></el-option>
              <el-option label="月选择器" value="month"></el-option>
              <el-option label="日期选择器" value="date"></el-option>
              <el-option label="周选择器" value="week"></el-option>
              <!--              <el-option label="季度选择器" value="quarter"></el-option>-->
            </el-select>
          </el-form-item>

          <!--          <el-form-item v-if="viewColumnForm.mode == 'date'" label="是否显示时间" label-width="110px">-->
          <!--            <el-radio v-model="viewColumnForm.showTime" :label="true">是</el-radio>-->
          <!--            <el-radio v-model="viewColumnForm.showTime" :label="false">否</el-radio>-->
          <!--          </el-form-item>-->

          <el-form-item
            v-if="
              viewColumnForm.mode == 'month' || viewColumnForm.mode == 'date'
            "
            label="是否范围选择"
            label-width="110px"
          >
            <el-radio v-model="viewColumnForm.range" :label="true">是</el-radio>
            <el-radio
              v-model="viewColumnForm.range"
              :label="false"
            >否</el-radio>
          </el-form-item>
        </div>
        <!-- 编辑器相关 -->
        <!--        <div v-if="['codeEditor', 'editor','wangEditor'].includes(viewColumnRow.view_type)">-->
        <!--          <el-form-item label="编辑器高度" label-width="110px">-->
        <!--            <el-input v-model="viewColumnForm.height" />-->
        <!--          </el-form-item>-->
        <!--        </div>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewComponentVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="viewComponentSub(viewColumnRow.column_name, viewColumnForm)"
        >保存</el-button>
      </div>
    </el-dialog>

    <a ref="aRef" :href="uploadHref" target="_self" style="display: none;"></a>
  </div>
</template>

<script>
import api from '@/api/generate_tables' // 和数据交互相关写在api 方便复用
import generate_columns from '@/api/generate_columns' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import CodeEdit from './components/CodeEdit'
import { viewComponent } from './var'
import dict_type from '@/api/system/dict_type'

export default {
  name: 'Generate',
  components: { Pagination, CodeEdit },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        title: [
          {
            required: true,
            message: '请输入文章名称',
            trigger: ['blur', 'change']
          }
        ]
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id',
        type: 1
      },
      // 数据库
      DataListQuery: {
        page: 1,
        limit: 10, // 页大小
        title: '' // 页大小
      },
      loading: false,
      dialogDataVisible: false,
      DataBaselist: [],
      DataBasetotal: 0,
      // 代码生成相关
      subData: {
        generate_type: 1,
        type: 'single',
        columns: [],
        generate_menus: [],
        options: {
          relations: [
            {
              name: '', // 关联名称
              type: '', // 关联类型
              table: '', // 关联表
              foreignKey: '', // 外键
              localKey: '', // 主键
              model: '' // 关联模型
            }
          ]
        }
      },
      queryTypeOptions: [
        { label: '=', value: 'eq' },
        { label: '!=', value: 'neq' },
        { label: '>', value: 'gt' },
        { label: '>=', value: 'gte' },
        { label: '<', value: 'lt' },
        { label: '<=', value: 'lte' },
        { label: 'LIKE', value: 'like' },
        { label: 'IN', value: 'in' },
        { label: 'NOT IN', value: 'notin' },
        { label: 'BETWEEN', value: 'between' }
      ],
      menuList: [
        {
          name: '新增',
          value: 'save',
          comment: '勾选生成新增数据按钮菜单及接口'
        },
        {
          name: '更新',
          value: 'update',
          comment: '勾选生成更新数据按钮菜单及接口'
        },
        {
          name: '读取',
          value: 'read',
          comment: '勾选生成读取数据按钮菜单及接口'
        },
        {
          name: '删除',
          value: 'delete',
          comment: '勾选生成真实删除按钮菜单及接口'
        },
        // { name: '回收站列表', value: 'recycle', comment: '勾选生成移到回收站列表、真实删除、恢复菜单及接口，确定该表有deleted_at字段，且模型引入了软删除。' },
        {
          name: '修改状态',
          value: 'changeStatus',
          comment: '勾选生成修改状态按钮菜单及接口，该接口用于单个字段状态修改'
        },
        {
          name: '自增自减',
          value: 'numberOperation',
          comment:
            '勾选生成数据自增自减按钮菜单及接口，该接口用于单个字段增减操作'
        },
        {
          name: '导入',
          value: 'import',
          comment: '勾选生成导入按钮菜单、接口和DTO文件'
        },
        {
          name: '导出',
          value: 'export',
          comment: '勾选生成导出按钮菜单、接口和DTO文件'
        }
      ],
      realtionsType: [
        { name: '一对一', value: 'hasOne' },
        { name: '一对多', value: 'hasMany' },
        { name: '一对多（反向)', value: 'belongsTo' },
        { name: '多对多', value: 'belongsToMany' }
      ],
      viewComponent: viewComponent,
      // 预览
      dialogPreviewVisible: false,
      PreviewData: [],
      uploadHref: '',
      // 页面参数设置
      viewComponentVisible: false,
      notNeedSettingComponents: [
        'text',
        'password',
        'textarea',
        'formGroup',
        'inputTag',
        'mention',
        'rate',
        'userInfo',
        'wangEditor',
        'upload'
      ],
      viewColumnRow: {},
      viewColumnForm: {
        collection: [{ label: '', value: '' }]
      },
      dict_type: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    add() {
      // this.$set(this.viewColumnForm.collection, this.viewColumnForm.collection.length, { label: '', value: '' })
      this.viewColumnForm.collection.push({ label: '', value: '' })
    },
    del(idx) {
      this.viewColumnForm.collection.splice(idx, 1)
    },
    // 保存数据
    viewComponentSub(name, value) {
      this.subData.columns.find((item, idx) => {
        // eslint-disable-next-line eqeqeq
        if (item.column_name == name) {
          this.subData.columns[idx].options = value
        }
      })
      this.viewComponentVisible = false
      this.$notify({
        title: '成功',
        message: '设置组件参数成功',
        type: 'success',
        duration: 2000
      })
    },
    // 页面控件参数
    viewComponentSetting(row) {
      this.viewComponentVisible = true
      this.viewColumnRow = row
      this.viewColumnForm = row.options ? row.options : { collection: [] }
      // form.value = record.options ? record.options : { collection: [] }
    },
    // 生产代码
    generate(row) {
      const url =
        process.env.VUE_APP_BASE_API +
        'admin/generate.generate_tables/generate?id=' +
        row.id
      this.uploadHref = url
      this.$nextTick(() => {
        this.$refs.aRef.click()
      })
    },
    // 数据表
    LoadDataTable() {
      this.dialogDataVisible = true
      this.DataBaseList()
    },
    // 搜索数据表
    SearchBaseData() {
      this.DataListQuery.page = 1
      this.DataBaseList()
    },
    // 加载数据库数据列表
    DataBaseList() {
      this.loading = true
      this.api.DataBaseList(this.DataListQuery).then(response => {
        this.DataBaselist = response.data.items
        this.DataBasetotal = response.data.total
        this.loading = false
      })
    },
    // 加载数据表-入库操作
    selectData(item) {
      const data = {
        name: item.Name,
        comment: item.Comment
      }
      this.api.LoadTable(data).then(response => {
        this.loadData()
        this.dialogDataVisible = false
      })
    },
    // 代码生成相关
    // 拉起编辑框
    HandleUpdate(row) {
      // this.subData.table_name = row.table_name
      // this.subData.table_comment = row.table_comment
      // this.subData.id = row.id
      // // this.subData = Object.assign({}, row) // copy obj
      this.api.Detail({ id: row.id }).then(response => {
        this.subData = response.data
        generate_columns
          .GetColumnList({ table: this.subData.id })
          .then(response => {
            this.$set(this.subData, 'columns', response.data)
          })
      })
      dict_type
        .Query({ sort: 'id', order: 'desc', isPaginator: false, status: 1 })
        .then(response => {
          this.dict_type = response.data
        })
      this.dialogFormVisible = true
    },
    // 增加关联模型
    addComposition() {
      this.subData.options.relations.push({
        name: '', // 关联名称
        type: '', // 关联类型
        table: '', // 关联表
        foreignKey: '', // 外键
        localKey: '', // 主键
        model: '' // 关联模型
      })
    },
    // 删除关联模型
    deleteComposition(index) {
      this.subData.options.relations.splice(index, 1)
    },
    // 提交编辑数据
    ConfirmUpdateData() {
      this.api.ConfirmUpdateData(this.subData).then(response => {
        this.loadData()
        this.$notify({
          title: '成功',
          message: '成功',
          type: 'success',
          duration: 2000
        })
        this.dialogFormVisible = false
      })
    },
    // 预览
    preview(row) {
      this.api.Preview({ id: row.id }).then(response => {
        this.dialogPreviewVisible = true
        this.PreviewData = response.data
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 1,
        type: 1,
        status: 1
      }
    }
  }
}
</script>
